import './Main.scss';

import Flickity from './General/SliderInit';

// Make Flickity global (used for events)
window.Flickity = Flickity;

// Resize Flickity on Page Load
document.addEventListener('DOMContentLoaded', event => {
    setTimeout(function() {
        [...document.querySelectorAll('.slider')].forEach(slider => {
            const flkty = Flickity.data(slider);
            if (flkty) {
                flkty.resize();
            }
        });
    }, 200);
});

// Pause / Unpause
let pausedClass = 'slider-pause-button--paused';

[...document.querySelectorAll('.slider-pause-button')].forEach(button => {
    button.addEventListener('click', () => {
        let flkty = Flickity.data(button.parentElement);
        window.flkty = flkty;
        console.log(flkty);
        if (button.classList.contains(pausedClass)) {
            button.classList.remove(pausedClass);
            button.setAttribute('aria-label', 'Slider pausieren');
            console.log('unpausing');
            flkty.playPlayer();
        } else {
            button.classList.add(pausedClass);
            button.setAttribute('aria-label', 'Slider weiter abspielen');
            console.log('pausing..');
            flkty.stopPlayer();
        }
    });
});
